export default __webpack_public_path__ + "static/media/chat-example.cdd47490.png";